import { makeStyles } from '@material-ui/core/styles';

// A minimal, purpose-built replacement for MUI's <CssBaseline /> — its only actual
// job here (PR-3798, dark mode) was making the body background/text follow the
// active theme palette. CssBaseline also throws in box-sizing: border-box globally,
// which breaks any element across this ~230-file legacy app that has an explicit
// width + padding tuned for the browser's content-box default (confirmed: the
// newsletter-creation screen's Select dropdowns overlap once box-sizing flips —
// see selectInputFormControl / dropdownIconComponent in ganaralStyle.js), plus a
// body font-family override this app never asked for. This component does only the
// one thing that was actually needed, so it can't reintroduce that class of bug on
// any of the many screens nothing has manually re-verified yet.
//
// Light mode intentionally gets NO override at all (verified by directly diffing
// computed styles against master): before this component existed, <body> had no
// explicit background/color anywhere — it fell through to the browser's own
// default white canvas and black text, never actually painted by anything. Only
// dark mode — genuinely new behavior, no prior state to match — gets an explicit
// background/color, so light mode's <body> stays byte-for-byte what it already was.
const useStyles = makeStyles((theme) => ({
  // Uses theme.custom.* (the dedicated chrome token namespace), not
  // theme.palette.background/text — those standard MUI keys are frozen to always-light
  // in theme.js for the sake of the many screens dark mode hasn't reached yet; reading
  // them here would paint the body light even in dark mode.
  //
  // Guarded by html[data-theme="dark"]: MUI removes a replaced sheet only after the re-render
  // commits, so on a theme switch the old dark rule briefly lingers. The attribute flips
  // synchronously, so the guard stops it matching at once (needed for the light-mode print
  // switch in App.js, whose snapshot is taken before that cleanup runs).
  '@global': theme.palette.type === 'dark' ? {
    'html[data-theme="dark"] body': {
      backgroundColor: theme.custom.toolbarBackground,
      color: theme.custom.toolbarText,
    },
  } : {},
}));

const AppBaseline = () => {
  useStyles();
  return null;
};

export default AppBaseline;
